import React from 'react';
import { McLoadingIndicator } from '@maersk-global/mds-react-wrapper/components-core/mc-loading-indicator';

interface FullScreenLoaderProps {
  message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ message }) => (
  <div
    className="mds"
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      backgroundColor: 'var(--mds-color-neutral-white, #FFFFFF)'
    }}
  >
    <McLoadingIndicator />
    {message && (
      <span className="mds-text--medium-regular" style={{ color: 'var(--mds-color-neutral-weaker-text)' }}>
        {message}
      </span>
    )}
  </div>
);

export default FullScreenLoader;
